import loadable from '@loadable/component';
export const manifest = {
  'SmeTariffsComparator.DropDown': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorDropDown";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorDropDown" */
          './src/components/shared/drop-down'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/drop-down");
            }

            return eval('require.resolve')("./src/components/shared/drop-down");
          }

        }, {
          resolveComponent: mod => mod.DropDown
        })
      }
    }
  },
  'SmeTariffsComparator.Provider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorProvider" */
          './src/components/shared/comparator-provider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/comparator-provider");
            }

            return eval('require.resolve')("./src/components/shared/comparator-provider");
          }

        }, {
          resolveComponent: mod => mod.ComparatorProvider
        })
      }
    }
  },
  'SmeTariffsComparator.ComparatorButton': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorComparatorButton";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorComparatorButton" */
          './src/components/desktop/comparator-button'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/comparator-button");
            }

            return eval('require.resolve')("./src/components/desktop/comparator-button");
          }

        }, {
          resolveComponent: mod => mod.ComparatorButton
        })
      }
    }
  },
  'SmeTariffsComparator.ComparatorSelectAll': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorComparatorSelectAll";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorComparatorSelectAll" */
          './src/components/desktop/comparator-select-all'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/comparator-select-all");
            }

            return eval('require.resolve')("./src/components/desktop/comparator-select-all");
          }

        }, {
          resolveComponent: mod => mod.ComparatorSelectAll
        })
      }
    }
  },
  'SmeTariffsComparator.Tariff': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTariff";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTariff" */
          './src/components/desktop/tariff/tariff'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/tariff/tariff");
            }

            return eval('require.resolve')("./src/components/desktop/tariff/tariff");
          }

        }, {
          resolveComponent: mod => mod.Tariff
        })
      }
    }
  },
  'SmeTariffsComparator.TariffStickyTable': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTariffStickyTable";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTariffStickyTable" */
          './src/components/desktop/tariff-sticky-table'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/tariff-sticky-table");
            }

            return eval('require.resolve')("./src/components/desktop/tariff-sticky-table");
          }

        }, {
          resolveComponent: mod => mod.TariffStickyTable
        })
      }
    }
  },
  'SmeTariffsComparator.TariffStickyTableRow': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTariffStickyTableRow";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTariffStickyTableRow" */
          './src/components/desktop/tariff-sticky-table-row'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/tariff-sticky-table-row");
            }

            return eval('require.resolve')("./src/components/desktop/tariff-sticky-table-row");
          }

        }, {
          resolveComponent: mod => mod.TariffStickyTableRow
        })
      }
    }
  },
  'SmeTariffsComparator.SliderField': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorSliderFieldDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorSliderFieldDesktop" */
          './src/components/shared/slider-field/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/slider-field/desktop");
            }

            return eval('require.resolve')("./src/components/shared/slider-field/desktop");
          }

        }, {
          resolveComponent: mod => mod.TariffsSliderFieldDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorSliderFieldMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorSliderFieldMobile" */
          './src/components/shared/slider-field/mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/slider-field/mobile");
            }

            return eval('require.resolve')("./src/components/shared/slider-field/mobile");
          }

        }, {
          resolveComponent: mod => mod.TariffsSliderFieldMobile
        })
      }
    }
  },
  'SmeTariffsComparator.InputField': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorInputField";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorInputField" */
          './src/components/mobile/input-field'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/mobile/input-field");
            }

            return eval('require.resolve')("./src/components/mobile/input-field");
          }

        }, {
          resolveComponent: mod => mod.TariffsInputField
        })
      }
    }
  },
  'SmeTariffsComparator.SliderFieldTooltip': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorSliderFieldTooltip";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorSliderFieldTooltip" */
          './src/components/shared/slider-field-tooltip'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/slider-field-tooltip");
            }

            return eval('require.resolve')("./src/components/shared/slider-field-tooltip");
          }

        }, {
          resolveComponent: mod => mod.SliderFieldTooltip
        })
      }
    }
  },
  'SmeTariffsComparator.FieldValueReset': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorFieldValueReset";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorFieldValueReset" */
          './src/components/shared/field-value-reset'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/field-value-reset");
            }

            return eval('require.resolve')("./src/components/shared/field-value-reset");
          }

        }, {
          resolveComponent: mod => mod.FieldValueReset
        })
      }
    }
  },
  'SmeTariffsComparator.TagField': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTagFieldDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTagFieldDesktop" */
          './src/components/desktop/tag-field/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/tag-field/desktop");
            }

            return eval('require.resolve')("./src/components/desktop/tag-field/desktop");
          }

        }, {
          resolveComponent: mod => mod.TariffsTagFieldDesktop
        })
      }
    }
  },
  'SmeTariffsComparator.TariffsCheckbox': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTariffsCheckboxDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTariffsCheckboxDesktop" */
          './src/components/desktop/tariff/components/tariffs-checkbox/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/tariff/components/tariffs-checkbox/desktop");
            }

            return eval('require.resolve')("./src/components/desktop/tariff/components/tariffs-checkbox/desktop");
          }

        }, {
          resolveComponent: mod => mod.TariffsCheckbox
        })
      }
    }
  },
  'SmeTariffsComparator.ComparatorIcon': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorComparatorIcon";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorComparatorIcon" */
          './src/components/desktop/comparator-icon'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/comparator-icon");
            }

            return eval('require.resolve')("./src/components/desktop/comparator-icon");
          }

        }, {
          resolveComponent: mod => mod.ComparatorIcon
        })
      }
    }
  },
  'SmeTariffsComparator.SortingWrapper': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorSortingWrapper";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorSortingWrapper" */
          './src/components/shared/sorting/sorting-wrapper'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/sorting/sorting-wrapper");
            }

            return eval('require.resolve')("./src/components/shared/sorting/sorting-wrapper");
          }

        }, {
          resolveComponent: mod => mod.SortingWrapper
        })
      }
    }
  },
  'SmeTariffsComparator.SortingItem': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorSortingItem";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorSortingItem" */
          './src/components/shared/tariff-sorting-item'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/shared/tariff-sorting-item");
            }

            return eval('require.resolve')("./src/components/shared/tariff-sorting-item");
          }

        }, {
          resolveComponent: mod => mod.TariffSortingItem
        })
      }
    }
  },
  'SmeTariffsComparator.MailtoButton': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorPostMessageButton";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorPostMessageButton" */
          './src/components/desktop/mailto-button'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/desktop/mailto-button");
            }

            return eval('require.resolve')("./src/components/desktop/mailto-button");
          }

        }, {
          resolveComponent: mod => mod.MailtoButton
        })
      }
    }
  },
  'SmeTariffsComparator.TariffCardSticky': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTariffCardSticky";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTariffCardSticky" */
          './src/components/mobile/tariff-card-sticky'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/mobile/tariff-card-sticky");
            }

            return eval('require.resolve')("./src/components/mobile/tariff-card-sticky");
          }

        }, {
          resolveComponent: mod => mod.TariffCardSticky
        })
      }
    }
  },
  'SmeTariffsComparator.TariffCard': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTariffCard";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTariffCard" */
          './src/components/mobile/tariff-card'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/mobile/tariff-card");
            }

            return eval('require.resolve')("./src/components/mobile/tariff-card");
          }

        }, {
          resolveComponent: mod => mod.TariffCard
        })
      }
    }
  },
  'SmeTariffsComparator.TabsPanel': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsComparatorTabsPanel";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsComparatorTabsPanel" */
          './src/components/mobile/tabs-panel'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/mobile/tabs-panel");
            }

            return eval('require.resolve')("./src/components/mobile/tabs-panel");
          }

        }, {
          resolveComponent: mod => mod.CacheTabsPanel
        })
      }
    }
  }
};